// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.K7FHZxe55JWEcVSQgZAE.zVUbywIlP7CTEF8mNhuP {
  pointer-events: auto;
}
.K7FHZxe55JWEcVSQgZAE.avHvNAc0NPe_jFHpdHjv .tooltip-inner {
  min-width: 70px;
  max-width: 200px;
  padding: 2px 8px 4px;
  font-size: 12px;
}
.K7FHZxe55JWEcVSQgZAE.avHvNAc0NPe_jFHpdHjv .popover-body {
  padding: 3px 8px 4px;
}
.K7FHZxe55JWEcVSQgZAE.avHvNAc0NPe_jFHpdHjv .popover-header {
  padding: 3px 8px 4px;
  font-size: 12px;
}
.K7FHZxe55JWEcVSQgZAE.k0zRlI0WFh83wz1qAOyf .tooltip-inner {
  min-width: 70px;
  max-width: 250px;
  padding: 4px 10px 6px;
  font-size: 16px;
}
.K7FHZxe55JWEcVSQgZAE.k0zRlI0WFh83wz1qAOyf.popover {
  font-size: 14px;
}
.K7FHZxe55JWEcVSQgZAE .popover-header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.K7FHZxe55JWEcVSQgZAE.bs-tooltip-bottom[data-popper-placement="bottom-start"] .tooltip-inner, .K7FHZxe55JWEcVSQgZAE.bs-popover-bottom[data-popper-placement="bottom-start"] {
  margin-left: -25px;
}
.K7FHZxe55JWEcVSQgZAE.bs-popover-bottom[data-popper-placement="bottom-start"] .popover-arrow {
  margin-left: 25px;
}

.adMjlZJkYqca8P08p_RR {
  cursor: pointer;
}

._7nkMAhjV4Pf3YAxWe9Qp {
  border-bottom: dotted;
  border-bottom-color: #006cff;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/components/tooltip/Tooltip.module.scss"],"names":[],"mappings":"AAEE;EACE,oBAAA;AADJ;AAKI;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAHN;AAMI;EACE,oBAAA;AAJN;AAOI;EACE,oBAAA;EACA,eAAA;AALN;AAUI;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;AARN;AAWI;EACE,eAAA;AATN;AAaE;EACE,iDAAA;AAXJ;AAcE;EAEE,kBAAA;AAbJ;AAgBE;EACE,iBAAA;AAdJ;;AAkBA;EACE,eAAA;AAfF;;AAkBA;EACE,qBAAA;EACA,4BAAA;AAfF","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.tooltipComponent {\n  &.interactive {\n    pointer-events: auto;\n  }\n\n  &.tooltip-size-regular {\n    & :global(.tooltip-inner) {\n      min-width: 70px;\n      max-width: 200px;\n      padding: 2px 8px 4px;\n      font-size: 12px;\n    }\n\n    & :global(.popover-body) {\n      padding: 3px 8px 4px;\n    }\n\n    & :global(.popover-header) {\n      padding: 3px 8px 4px;\n      font-size: 12px;\n    }\n  }\n\n  &.tooltip-size-large {\n    & :global(.tooltip-inner) {\n      min-width: 70px;\n      max-width: 250px;\n      padding: 4px 10px 6px;\n      font-size: 16px;\n    }\n\n    &:global(.popover) {\n      font-size: 14px;\n    }\n  }\n\n  & :global(.popover-header) {\n    border-bottom: 1px solid rgba(white, 0.2);\n  }\n\n  &:global(.bs-tooltip-bottom[data-popper-placement=\"bottom-start\"] .tooltip-inner ),\n  &:global(.bs-popover-bottom[data-popper-placement=\"bottom-start\"]) {\n    margin-left: -25px;\n  }\n\n  &:global(.bs-popover-bottom[data-popper-placement=\"bottom-start\"] .popover-arrow) {\n    margin-left: 25px;\n  }\n}\n\n.tooltip-trigger-variant-click {\n  cursor: pointer;\n}\n\n.target-default-styling {\n  border-bottom: dotted;\n  border-bottom-color: #006cff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipComponent": `K7FHZxe55JWEcVSQgZAE`,
	"interactive": `zVUbywIlP7CTEF8mNhuP`,
	"tooltip-size-regular": `avHvNAc0NPe_jFHpdHjv`,
	"tooltip-size-large": `k0zRlI0WFh83wz1qAOyf`,
	"tooltip-trigger-variant-click": `adMjlZJkYqca8P08p_RR`,
	"target-default-styling": `_7nkMAhjV4Pf3YAxWe9Qp`
};
export default ___CSS_LOADER_EXPORT___;
